import { Button, type ButtonProps } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import type { ComponentProps } from 'react'

export type ButtonGroupProps = ComponentProps<'div'>

export type ButtonGroupButtonProps = ButtonProps & {
  divider?: boolean
}

function ButtonGroup({ className, ...props }: ButtonGroupProps) {
  return (
    <div
      role="group"
      data-slot="button-group"
      className={cn(
        'flex items-stretch overflow-hidden rounded-full border border-control-border bg-background dark:bg-card',
        className
      )}
      {...props}
    />
  )
}

function ButtonGroupButton({
  className,
  divider = false,
  variant = 'ghost',
  ...props
}: ButtonGroupButtonProps) {
  return (
    <Button
      variant={variant}
      data-slot="button-group-button"
      className={cn(
        'h-full rounded-none border-0 shadow-none',
        divider &&
          'relative before:pointer-events-none before:absolute before:inset-y-2 before:left-0 before:w-px before:bg-control-border after:pointer-events-none after:absolute after:inset-y-2 after:right-0 after:w-px after:bg-control-border',
        className
      )}
      {...props}
    />
  )
}

export { ButtonGroup, ButtonGroupButton }
